import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { PropertiesState, PROPERTIES_SLICE_NAME } from './models';

export const propertiesSelector = (state: RootState): PropertiesState => state[PROPERTIES_SLICE_NAME];

export const selectPropertiesIsLoading = createSelector(
  propertiesSelector,
  (state: PropertiesState) => state.isLoading,
);

export const selectProperties = createSelector(propertiesSelector, (state: PropertiesState) => state.properties);

export const selectAppliedFilters = createSelector(
  propertiesSelector,
  (state: PropertiesState) => state.appliedFilters,
);

export const selectAppliedSoldFilters = createSelector(
  propertiesSelector,
  (state: PropertiesState) => state.appliedSoldFilters,
);

export const selectPagination = createSelector(propertiesSelector, (state: PropertiesState) => state.pagination);

export const selectProperty = createSelector(propertiesSelector, (state: PropertiesState) => state.property);

export const selectPropertyError = createSelector(propertiesSelector, (state: PropertiesState) => state.error);
